<template>
  <v-flex
    id="changeNames"
    class="question"
  >
    <h2
      class="header"
      :class="{ required: getChangeNamesQuestions.new_names[0].new_name.required }"
    >
      {{ getChangeNamesQuestions.label }}
    </h2>
    <p class="fw-400">
      {{ $t('sheet.sheet_two.change_names.hint') }}
    </p>
    <v-layout
      v-if="getChangeNamesQuestions.hasOwnProperty('new_names')"
      align-center
      wrap
    >
      <v-flex
        v-for="(item, index) in newNames"
        :key="index"
        xs12
        :class="[{ 'personal-form personal-form_bordered': item.complete }]"
      >
        <v-layout :wrap="$vuetify.breakpoint.smAndDown">
          <v-flex
            class="mt-4 mr-2"
            shrink
          >
            <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
          </v-flex>
          <v-flex
            lg3
            md4
          >
            <v-text-field
              :ref="createDataName('origin_name', index)"
              :label="getChangeNamesQuestions.new_names[0].name.label"
              class="ml-1 personal-input_disabled"
              :value="item.name"
              disabled
            />
          </v-flex>
          <v-flex
            lg3
            md4
          >
            <v-text-field
              v-model="item.newName"
              v-validate="validateRule(index)"
              :label="getChangeNamesQuestions.new_names[0].new_name.label"
              class="ml-1"
              :error-messages="errors.collect(createDataName('changed_name', index))"
              :data-vv-as="$t('sheet.sheet_two.change_names.labels.changed_name')"
              :data-vv-name="createDataName('changed_name', index)"
              :required="getChangeNamesQuestions.new_names[0].new_name.required"
              :disabled="readOnly"
            />
            <div
              v-if="item.error"
              class="v-message my-4 text-xs-center"
            >
              <div class="v-messages__message">
                {{ item.error }}
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getChangedNamesField',
    mutationType: 'sheet/updateChangedNamesField'
});

export default {
    name: 'ChangeNames',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules,
            emptyMembersData: {
                error: '',
                newName: ''
            },
            representatives: []
        };
    },
    computed: {
        mdAndUp () {
            return this.$vuetify.breakpoint.mdAndUp;
        },
        ...mapFields(['newNames']),
        partialData () {
            return this.$store.getters['sheet/getPartialSheetData'];
        },
        ...mapGetters('sheet', ['getChangeNamesQuestions'])
    },
    created () {
        if (this.partialData && this.partialData.familyGuideRepresentatives) {
            this.representatives = this.partialData.familyGuideRepresentatives;
        }
        this.createMembers(this.representatives);
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        falseComplete (el) {
            el = false;
        },
        validateRule (index) {
            return {
                ...this.validationRules.get('changed_name'),
                same_names: this.createDataName('origin_name', index)
            };
        },
        createMembers (val) {
            if (val != null && val.length > 0) {
                let tmpData = [];
                const tmpEmpty = [];
                val.forEach((member) => {
                    this.newNames.forEach((mD) => {
                        if (member.firstName === mD.name) {
                            tmpData.push(mD);
                        }
                    });

                    if (
                        tmpData.find((el) => {
                            return el.name === member.firstName;
                        }) == null
                    ) {
                        tmpEmpty.push({
                            name: member.firstName,
                            id: member.id,
                            ...this.emptyMembersData
                        });
                    }
                });
                tmpData = tmpData.concat(tmpEmpty);
                this.newNames = tmpData;
            }
        }
    }
};
</script>

<style scoped></style>
